/**
 * Maps backend vehicle type values to user-friendly display names
 * @param {string} vehicleType - The backend vehicle type value
 * @returns {string} - User-friendly display name
 */
export const getVehicleTypeDisplayName = (vehicleType) => {
  const vehicleTypeMap = {
    'two_wheeler': 'Two Wheeler',
    'four_wheeler': 'Four Wheeler',
    'commercial_vehicle': 'Commercial Vehicle'
  };

  return vehicleTypeMap[vehicleType] || vehicleType || '-';
};
